export enum ModuleType {
  'service' = 'service',
  'services' = 'services',
  'project' = 'project',
  'projects' = 'projects',
  'investment' = 'investment',
}
